<template>
    <!-- 余额变动 -->
    <div class='balance-change'>
        <p class="required">会员积分变动保留最近一年的记录</p>
        <el-table v-loading="isLoading"
            ref="elTable"
            style="width: 100%"
            :height="'100%'"
            :data="balanceCharge"
            :empty-text="isLoading ? ' ' : '暂无数据'">
            <el-table-column label="#" type="index" min-width="50"/>
            <el-table-column
                label="时间"
                min-width="160">
                <template v-slot="{ row }">
                    <p>{{ getTime(row.create_time).y_m_d }}</p>
                    <p>{{ getTime(row.create_time).h_m_s }}</p>
                </template>
            </el-table-column>
            <el-table-column
                min-width="190">
                <template v-slot:header="{ row }">
                    <table-data-filter :headerTitle="'变动类型'"
                        :title="'变动类型'"
                        :allString="'所有变动类型'"
                        :items="[{
                            id: 0,
                            name: '订单消费'
                        }, {
                            id: 1,
                            name: '订单退款'
                        }]"
                        :itemKeyCode="'id'"
                        :itemKeyName="'name'"
                        v-model="RecordTypeList"
                        @confirm="tableFilterConfirm"/>
                </template>
                <template v-slot="{ row }">
                    <span>{{ getRecordType(row.change_type) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="订单号"
                min-width="170">
                <template v-slot="{ row }">
                    <span class="text-popper" v-textPopper>{{ row.order_no }}</span>
                </template>
            </el-table-column>
            <el-table-column
                align="right"
                label="变动积分"
                min-width="110">
                <template v-slot="{ row }">
                    <span :class="{ 'color-red': row.change_points < 0 }" style="width: auto; max-width: calc(100% - 20px)" class="text-popper" v-textPopper>
                        {{ row.change_points > 0 ? '+' : '' }}
                        {{ (+row.change_points).toFixed(2) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                align="right"
                label="变动后积分"
                min-width="120">
                <template v-slot="{ row }">
                    <span class="text-popper" v-textPopper v-numberAlign>{{ row.remain_points }}</span>
                </template>
            </el-table-column>
            <el-table-column min-width="20"/>
            <el-table-column
                label="操作人"
                width="280">
                <template v-slot="{ row }">
                    <user-info v-if="get(row, 'creator.id') != null" :userInfo="get(row, 'creator.user')" :maxWidth="'calc(100% - 70px)'"/>
                    <span class="cashier">{{ '收银员' }}</span>
                </template>
            </el-table-column>
            <p v-if="isHasMore && isScrollLoading" slot="append" style="text-align: center; padding: 10px;">
                <span class="loading-step-animation">正在加载...</span>
            </p>
            <p v-if="(!isHasMore) && balanceCharge.length > 0" slot="append" style="text-align: center; padding: 10px;">没有更多了</p>
        </el-table>
    </div>
</template>

<script lang="ts">
import TableDataFilter from '@/components/table_data_filter/table_data_filter.vue'
import { onBeforeMount, onMounted, ref, createComponent } from '@vue/composition-api'
import { openMessage, useScrollLoad } from '@/utils/system.tsx'
import $fetch from '@/api'
import clone from 'lodash/cloneDeep'
import get from 'lodash/get'
import { setObjectItemToFixed } from '@/utils/index'

export default createComponent({
    setup(props, ctx) {
        const query = ctx.root.$route.query
        const id: string | Array<string | null> = query.id
        const intId: number = +id
        // reactive data
        const balanceCharge = ref([])
        const RecordTypeList = ref([0, 1, 2, 3])
        const isLoading = ref(false)
        const {
            page: oPage,
            isHasMore,
            isLoading: isScrollLoading,
            bindListener,
            initScrollLoad
        } = useScrollLoad()

        // 组件的入口
        onBeforeMount(() => {
            isLoading.value = true
            getBalanceChange().then(() => isLoading.value = false)
        })

        onMounted(() => {
            bindListener({
                dom: (ctx.refs.elTable as any).$el.querySelector('.el-table__body-wrapper'),
                loadFunction: getBalanceChange
            })
        })

        const getTime = (t: string) => {
            if (!t) { return {} }
            const arr = t.split(' ')
            return {
                y_m_d: arr[0],
                h_m_s: arr[1]
            }
        }

        const getBalanceChange = (page = oPage.value, limit = 20, recordTypeList = RecordTypeList.value) => {
            return $fetch.post({
                url: '/membership/memberpointsrecords',
                params: {
                    member_id: intId,
                    change_type: recordTypeList,
                    page,
                    limit
                }
            }).then(data => {
                console.log('余额变动', clone(data))
                data.balance_record_list = data.points_change_record_list.filter(l => +l.changed_amount !== 0)
                data = setObjectItemToFixed(data)
                if (page === 1) {
                    balanceCharge.value = data.points_change_record_list
                    initScrollLoad(data)
                } else {
                    balanceCharge.value = balanceCharge.value.concat(data.points_change_record_list)
                }
                return data
            }).catch(e => openMessage('error', e.message || '获取余额变动信息失败'))
        }

        const getRecordType = (type) => {
            const arr = ['订单消费', '订单退款']
            return arr[type]
        }

        const tableFilterConfirm = () => {
            oPage.value = 1
            isHasMore.value = true
            isLoading.value = true
            getBalanceChange().then(() => isLoading.value = false)
        }

        return {
            // data
            isScrollLoading,
            isHasMore,
            isLoading,
            getTime,
            balanceCharge,
            RecordTypeList,
            // methods
            getRecordType,
            get,
            getBalanceChange,
            tableFilterConfirm
        }
    },
    components: {
        TableDataFilter
    }
})
</script>

<style lang="scss" scoped>
.required {
    margin: 10px 10px 0;
    font-size: 14px;
    color: #151515;
    letter-spacing: 0;
    line-height: 20px;
}

.cashier {
    display: inline-block;
    width: 50px;
    height: 22px;
    line-height: 22px;
    margin-left: 10px;
    text-align: center;
    vertical-align: middle;
    box-sizing: border-box;
    color: #009688;
    border: 1px solid #009688;
    border-radius: 2px;
}

::v-deep .el-table_1_column_8  {
    .cell{
        display: flex;
        align-items: center;
    }

    .user-info {
        flex: none;
    }
}

::v-deep .el-table_1_column_3 {
    .cell {
        display: flex;
        align-items: center;
    }
}
</style>